import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ToastsContainer from 'components/pages/ToastsContainer'

import actions from './actions'
import { selectToasts } from './selectors'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actions, dispatch),
  dispatch, // Pass dispatch for custom actions
})
const mapStateToProps = (state) => ({
  toasts: selectToasts(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(ToastsContainer)

export default render
